// extracted by mini-css-extract-plugin
export default {"Haricot":"#01A92B","Basa":"#EAEBEC","paymentInfo":"Gf79e81","row":"Gb61d87 Gb87295 Gcef598 G2fbcdc","bold":"G0d84e9 Gd6846a","green":"G725fe0","separationBelow":"G05c36d"};